import Swal from "sweetalert2"

export const successAlert = (title = "") => {
  
    Swal.fire({
        position: 'top',
        icon: 'success',
        title: title,
        showConfirmButton: false,
        timer: 1500
      })
  }
  export const errorAlert = (title = "") => {
    Swal.fire({
        position: 'top',
        icon: 'error',
        text: title,
        showConfirmButton: false,
        timer: 3500
      })
  }
  
  export const resizeBase64 = (base64Image, maxSizeInMB = 0.5) => {
    return new Promise((resolve, reject) => {
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
      const img = new Image();
      img.src = base64Image;
      img.onload = function () {
        const canvas = document.createElement("canvas");
        // Enable alpha channel to preserve transparency
        const ctx = canvas.getContext('2d', { alpha: true });
        const width = img.width;
        const height = img.height;
        const aspectRatio = width / height;
        const newWidth = Math.sqrt(maxSizeInBytes * aspectRatio);
        const newHeight = Math.sqrt(maxSizeInBytes / aspectRatio);
        canvas.width = newWidth;
        canvas.height = newHeight;
        
        // Clear canvas with transparent background
        ctx.clearRect(0, 0, newWidth, newHeight);
        
        // Draw image with high quality settings
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        
        // Determine if the original image is PNG (likely has transparency)
        const isPNG = base64Image.indexOf('data:image/png') === 0;
        
        // Use PNG format if original was PNG to preserve transparency, otherwise use JPEG
        let dataURL;
        if (isPNG) {
          dataURL = canvas.toDataURL('image/png');
        } else {
          let quality = 0.8;
          dataURL = canvas.toDataURL('image/jpeg', quality);
        }
        
        resolve(dataURL);
      };
    });
  }
  export const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
  
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
  
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

    export const sortByOrder = ( a, b ) => {

    return a?.order?.toString()?.localeCompare(b?.order?.toString(), undefined, {

      numeric: true,
      sensitivity: 'base'
    })}